import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled from 'styled-components';
import { g as getRem } from './styled-utils-3f8463ca.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  margin-left: .5rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIcon = styled.svg(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      size = _ref.size;
  return getRem(theme.fontSizes[size]);
}, function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size;
  return getRem(theme.fontSizes[size]);
});

var ExternalIcon = function ExternalIcon(_ref3) {
  var size = _ref3.size;
  return React.createElement(StyledIcon, {
    viewBox: "0 0 16 16",
    size: size
  }, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6036 1H14.75C14.8881 1 15 1.11193 15 1.25V5.39645C15 5.61917 14.7307 5.73072 14.5732 5.57322L13.0303 4.03033L9.28033 7.78033C8.98744 8.07322 8.51256 8.07322 8.21967 7.78033C7.92678 7.48744 7.92678 7.01256 8.21967 6.71967L11.9697 2.96967L10.4268 1.42678C10.2693 1.26929 10.3808 1 10.6036 1ZM3.75 2C2.7835 2 2 2.7835 2 3.75V12.25C2 13.2165 2.7835 14 3.75 14H12.25C13.2165 14 14 13.2165 14 12.25V8.75C14 8.33579 13.6642 8 13.25 8C12.8358 8 12.5 8.33579 12.5 8.75V12.25C12.5 12.3881 12.3881 12.5 12.25 12.5H3.75C3.61193 12.5 3.5 12.3881 3.5 12.25V3.75C3.5 3.61193 3.61193 3.5 3.75 3.5H7.25C7.66421 3.5 8 3.16421 8 2.75C8 2.33579 7.66421 2 7.25 2H3.75Z"
  }));
};

ExternalIcon.defaultProps = {
  size: 'sm'
};

var Link = function Link(_ref4) {
  var children = _ref4.children,
      href = _ref4.href,
      newTab = _ref4.newTab,
      isExternal = _ref4.isExternal,
      className = _ref4.className;
  return React.createElement("a", {
    href: href,
    target: newTab || isExternal ? '_blank' : '',
    className: className
  }, children, isExternal && React.createElement(ExternalIcon, {
    size: "xs"
  }));
};

Link.defaultProps = {
  className: null,
  isExternal: false,
  newTab: false
};
Link.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Link",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "isExternal": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not the Link points to an external site"
    },
    "newTab": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not to launch the Link in a new tab/window"
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": true,
      "description": "The content of the Link"
    },
    "href": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "The URL the Link points to."
    }
  }
};
export default Link;
export { Link };